import React, { useState } from 'react';
import Globals from '../../contexts/Globals';
import I18nLib from '../../lib/I18nLib';
import { log, logRender, logError } from '../../lib/Debug';

import BlackoutAPI from '../../lib/BlackoutAPI';
import LoaderButton from '../LoaderButton';

function RedeemCode({ clubId, onClose }) {
	
	let globals = Globals.useContainer();
	let i18n = I18nLib.init(globals);
	
	let [code, setCode] = useState('');
	let [isRedeeming, setIsRedeeming] = useState(false);
	let [validationMessage, setValidationMessage] = useState(null);
	let [successData, setSuccessData] = useState(null);

	const handleChange = (e) => {
		setCode(e.target.value);
		if(validationMessage){
			setValidationMessage(null);
		}
	};
	
	const handleFocus = () => {
		if(validationMessage){
			setValidationMessage(null);
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			redeemCode();
		}
	};

	const redeemCode = () => {
		if(!code || !code.trim()){
			setValidationMessage(i18n('redeem-code.error-empty','Please enter a code'));
			return;
		}

		setIsRedeeming(true);
		setValidationMessage(null);
		
		BlackoutAPI.post({
			endpoint: 'redeem-code',
			headers: {
				Token: globals.userState.token.accessToken,
				'current-club': clubId,
				'Content-Type': 'application/vnd.api+json',
				'Build-Version': '999.0.0', // Must provide build version, just add a high one
			},
			data: {
				data: {
					type: 'redeem-code',
					attributes: {
						code: code.trim()
					}
				}
			}
		}).then(res=>{
			setIsRedeeming(false);
			
			log(`redeemCode`,res);
			
			let description = '';
			if(res.included && res.included.length > 0){
				const storeItem = res.included[0];
				description = storeItem.description || storeItem.attributes?.description || '';
			}
			
			setSuccessData({
				description: description,
				message: i18n('redeem-code.success-message','Jump into the game to use your rewards!')
			});

		}).catch(err=>{
			setIsRedeeming(false);
			
			if(err.response){
				err = err.response;
				logError(`redeemCode`,err);
				if(err.data && err.data.errors && err.data.errors.message){
					setValidationMessage(err.data.errors.message);
				} else {
					setValidationMessage(i18n('account.error-see-console','Error. See console for details.'));
				}
			} else {
				setValidationMessage(i18n('account.error-see-console','Error. See console for details.'));
				logError(err);
			}
		});
	};

	const redeemCodeForm = () => {
		if(successData){
			return (
				<div className="center-text">
					<div style={{marginBottom: '1rem'}}>
						<span style={{fontSize: '2rem'}}>🎉 🎁</span>
					</div>
					{successData.description && (
						<div style={{marginBottom: '1rem', whiteSpace: 'pre-line'}}>
							{successData.description}
						</div>
					)}
					<div className="success-text" style={{fontWeight: 'bold', marginTop: '1rem'}}>
						{successData.message}
					</div>
				</div>
			);
		}

		return (
			<form onSubmit={(e) => { e.preventDefault(); redeemCode(); }}>
				<div className="input-container">
					<input 
						id='redeemCode' 
						type="text" 
						onChange={handleChange}
						onFocus={handleFocus}
						onKeyDown={handleKeyDown}
						placeholder={i18n('redeem-code.placeholder','Enter Code')}
						value={code}
						autoComplete='off'
					/>
					{validationMessage
						? <span className="validation-text"><span className="icon-attention" />{validationMessage}</span>
						: ''
					}
				</div>
				
				<LoaderButton
					onClick={redeemCode}
					className="sm"
					isLoading={isRedeeming}
				>{isRedeeming ? i18n('redeem-code.submitting','Redeeming...') : i18n('redeem-code.button','Redeem Code')}</LoaderButton>
			</form>
		);
	};

	logRender(`RedeemCode -- render`);

	return (
		<div style={{marginTop: '1rem'}}>
			{redeemCodeForm()}
		</div>
	);
	
}

export default RedeemCode;

